module.exports = __webpack_public_path__ + "img/album18_22.ce67d4aa.jpg";